<template>
	<div class="recall">
		<div class="d-flex align-items-center recall__header">
			<img :src="PhoneImage" alt="Visszahívás" class="recall__img">
			<p class="recall__title">Visszahívást kérek</p>
		</div>
		<input-unit v-model="email" :options="{
			type: 'text',
			slug: 'phone',
			class: 'recall__input',
			placeholder: 'Telefonszám'
		}"/>

		<honeypot-field v-model="honeypot"/>
		<privacy-notice/>

		<button-unit
				class="recall__btn"
				@click-on-btn="goToReCallEmail"
				:options="{
					text: 'Elküld',
					bgColor: '#F7F9EE',
					textColor: '#32341d',
				}"
		/>

	</div>
</template>
<script setup lang="ts">

import {defineEmits, ref} from "vue";
import PhoneImage from "@Images/phone.svg";
import InputUnit from "@/WebApp/Components/Units/InputUnit.vue";
import ButtonUnit from "@/WebApp/Components/Units/ButtonUnit.vue";
import HoneypotField from "@/WebApp/Components/Units/HoneypotField.vue";
import PrivacyNotice from "@/WebApp/Components/Units/PrivacyNotice.vue";
import {formErrorMessage, protectionPayload} from "@/WebApp/Utils/FormProtection";
import {customErrorAlert, customSuccessAlert} from "@WebAppComposable/SweetAlertComposable";
import axios from "axios";

const email: string = ref('');
const honeypot = ref('');
const emit = defineEmits(['clickOnBtn']);

const goToReCallEmail = (async () => {

	if (email.value.length === 0) {
		customErrorAlert('Nem adtál meg telefonszámot!');
		return;
	}

	const protection = await protectionPayload(honeypot.value, 'recall');
	axios.post('/api/recall', {phone: email.value, ...protection}).then((response: any) => {
		if (response.status === 200 && response.data.success === true) {
			customSuccessAlert('Hamarosan keresni fogjuk!', '');
		}
	}).catch((error: any) => {
		customErrorAlert('Valami hiba történt', formErrorMessage(error, error.response?.data?.message ?? ''));
	});
});

</script>
<style scoped>

</style>
